<form [formGroup]="formName">
    <input type="text" appTrimSpaces pInputText [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" pKeyFilter="num" class="w-full" [placeholder]="placeholder" />
</form>